import React, { useContext } from 'react'
import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { FiltrosHistorias } from '../context/historias.context'
import { ITenant } from '../../AbmLocalPage/types'

export const getHistorias = async (
  { idHistoria, codLocal, publicadosAhora, publicadosInstagram, creadoDesde, creadoHasta }: FiltrosHistorias,
  tenant: ITenant
) => {
  return await axiosInstanceMain.get(`/admin/${tenant.path}/historias`, {
    params: {
      ...(idHistoria && { idHistoria: idHistoria }),
      ...(codLocal && { codLocal: codLocal }),
      ...{ 'publicados-ahora': publicadosAhora },
      ...(publicadosInstagram !== null && {
        'publicados-instagram': publicadosInstagram
      }),
      ...(creadoDesde && { 'creado-desde': creadoDesde }),
      ...(creadoHasta && { 'creado-hasta': creadoHasta })
    }
  })
}

export const getHistoriasLocal = async (idLocal: number, tenant: ITenant, deviceId: string) => {
  return await axiosInstanceMain.get(
    `/${tenant.path}/historias?deviceId=${deviceId}&clave=347ebc28653419c788302d8eba55b75a&idLocal=${idLocal}`
  )
}

export const compartirHistoria = async (idHistoria: any, tenant: ITenant) => {
  await axiosInstanceMain.post(`/admin/${tenant.path}/historias/${idHistoria}/compartir`)
}

export const eliminarHistoria = async (idHistoria: any, tenant: ITenant) => {
  await axiosInstanceMain.delete(`/admin/${tenant.path}/historias/${idHistoria}`)
}

export const subirHistoria = async (image: File, codLocal: string, tenant: ITenant) => {
  const formData = new FormData()
  formData.append('codLocal', codLocal)
  formData.append('tipo', 'local')
  formData.append('foto', image, image.name)

  return await axiosInstanceMain.post(`/${tenant.path}/historias`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const eliminarHistoriaVendedor = async (idHistoria: any, tenant: ITenant) => {
  await axiosInstanceMain.delete(`/${tenant.path}/historias/${idHistoria}`)
}
